export default "__VITE_ASSET__x3RekWDD__"